import React, { useEffect } from 'react';

import { BasicModal } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';
import Classes from './LoginDialog.module.scss';

const LOGIN_IFRAME_NAME = 'loginIframe';

const LOGIN_IFRAME_EVENTS = {
  Closed: `${LOGIN_IFRAME_NAME}.closed`,
};

const LoginDialogApp = ({ onClose }: { onClose: Function }) => {
  const { t } = useI18nContext();

  useEffect(() => {
    const onMessage = (evt: MessageEvent) => {
      switch (evt.data?.type) {
        case LOGIN_IFRAME_EVENTS.Closed:
          document.location.reload();
          break;
      }
    };
    window.addEventListener('message', onMessage);

    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <BasicModal title={t('modal.login.title')} contentClassName="u-paddingNone" onClose={() => onClose()} size="s">
      <iframe
        name={LOGIN_IFRAME_NAME}
        className={Classes.iframe}
        src={'/identity/v2/login?mpEmbeddedInMobileApp=true'}
      />
    </BasicModal>
  );
};

export default LoginDialogApp;
